import { ReactElement, useEffect, useRef} from "react";
import "./index.css";

interface IProps {
  title: string;
  onClick?: ()=>void;
  status: "done" | "pass" | "access" | "off";
}

export function HabitDayPadItem(props: IProps): ReactElement {
  const dayref = useRef<HTMLDivElement>(null);
  useEffect(()=>{
    if(dayref.current && props.status === 'access'){
      dayref.current.scrollIntoView({behavior: "smooth", inline: "start"});
    }
  },[props.status]);
  let statusDayIconClass = "habitDayPadItem_ico";
  if (props.status === "done") {
    statusDayIconClass = statusDayIconClass + " done";
  } else if (props.status === "pass") {
    statusDayIconClass = statusDayIconClass + " pass";
  } else if (props.status === "access") {
    statusDayIconClass = statusDayIconClass + " access";
  } else if (props.status === "off") {
    statusDayIconClass = statusDayIconClass + " off";
  }
  return (
    <div className="habitDayPadItem" onClick={props.onClick} ref={dayref}>
      <div className={statusDayIconClass}></div>
      <span className="habitDayPadItem_text">{props.title}</span>
    </div>
  );
}
